import { AfterViewInit, Directive, ElementRef, inject, input, OnDestroy, output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ConfirmDialogComponent } from "../../main/confirm-dialog/confirm-dialog.component";

@Directive(
  {
    selector: '[confirm]',
  }
)
export class ConfirmDirective implements AfterViewInit, OnDestroy {

  confirmBody = input<string>();

  confirmTitle = input<string>();


  onClose = output<void>();
  
  onConfirm = output<void>();


  private dialog = inject(MatDialog);
  
  private domElementRef = inject(ElementRef);
  
  private handler: ((event: Event) => void) = undefined;

  ngAfterViewInit(): void {
    const fn = (event: Event) => {
      event.stopPropagation();

      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: this.confirmTitle(), body: this.confirmBody(),
        },
        minWidth: '300px',
      }).afterClosed().subscribe((result) => {
        if (result) {
          this.onConfirm.emit();
        }

        this.onClose.emit();
      });
    };

    this.domElementRef.nativeElement.addEventListener('click', fn);

    this.handler = fn;
  }
  
  ngOnDestroy(): void {
    this.domElementRef.nativeElement.removeEventListener('click', this.handler);
  }
}
